export default __webpack_public_path__ + "f318a8135cebc6292400929586c0b454.png";